module.exports = __webpack_public_path__ + "img/404.767bf39a.png";